<template>
    <div v-if="loaded">
        <toggle-content v-for="(item, index) in contentItems"
            name="faq"
            :label="item.faq_question"
            :index="index"
            icon="arrow">
            {{ getContent(item) }}
        </toggle-content>
    </div>
</template>

<script>
import ToggleContent from './ToggleContent.vue';

export default {
    name: 'FaqContent',
    data() {
        return {
            loaded: false,
            contentItems: []
        };
    },
    props: ['items'],
    mounted: function() {
        this.contentItems = JSON.parse(this.items);
        this.loaded = true;
    },
    methods: {
        getContent(item) {
            return item['faq_answer'];
        }
    },
    components: {
        ToggleContent: ToggleContent
    },
};
</script>